import { lazy } from "react";

const MainPage = lazy(() => import("./page"));

const routes = [
  {
    path: "/center-management/daily-equipment-assignment",
    component: MainPage,
    exact: false,
    name: "Equipos Médicos - Asignación Diaria"
  }
];

export default routes;
